import { useApiMonOrga } from '~/composables/api/useApiMonOrga'

export type MeOrgPosition = {
  dirLib: string
  domLib: string
  ageLib: string
  equLib: string
  secLib: string
}

/** Aligné sur GET /v1/me/org-positions (EquipePolicy : leader domaine / leader agence). */
export type ManagerOrganigramEditScope = {
  directionLeaders: Array<{ dirLib: string }>
  domainLeaders: Array<{ dirLib: string; domLib: string }>
  agenceLeaders: Array<{ dirLib: string; domLib: string; ageLib: string }>
}

type MeOrgPositionsResponse = {
  positions: MeOrgPosition[]
  managerOrganigramEditScope: ManagerOrganigramEditScope | null
}

export type MeOrgPositionsPayload = {
  positions: MeOrgPosition[]
  managerOrganigramEditScope: ManagerOrganigramEditScope | null
}

export function formatOrgPositionLabel(position: MeOrgPosition): string {
  const parts = [
    position.dirLib,
    position.domLib,
    position.ageLib,
    position.equLib,
    position.secLib,
  ].filter((segment) => segment && String(segment).trim().length > 0)
  return parts.join(' > ')
}

export async function fetchMyOrgPositions(): Promise<MeOrgPositionsPayload> {
  const response = await useApiMonOrga<MeOrgPositionsResponse>('GET', '/v1/me/org-positions')
  const positions = Array.isArray(response.positions) ? response.positions : []
  const managerOrganigramEditScope =
    response.managerOrganigramEditScope !== undefined &&
    response.managerOrganigramEditScope !== null &&
    typeof response.managerOrganigramEditScope === 'object'
      ? {
          directionLeaders: Array.isArray(response.managerOrganigramEditScope.directionLeaders)
            ? response.managerOrganigramEditScope.directionLeaders
            : [],
          domainLeaders: Array.isArray(response.managerOrganigramEditScope.domainLeaders)
            ? response.managerOrganigramEditScope.domainLeaders
            : [],
          agenceLeaders: Array.isArray(response.managerOrganigramEditScope.agenceLeaders)
            ? response.managerOrganigramEditScope.agenceLeaders
            : [],
        }
      : null
  return { positions, managerOrganigramEditScope }
}
